import { render, staticRenderFns } from "./EventCategory.vue?vue&type=template&id=de6244d6&scoped=true"
import script from "./EventCategory.vue?vue&type=script&lang=js"
export * from "./EventCategory.vue?vue&type=script&lang=js"
import style0 from "./EventCategory.vue?vue&type=style&index=0&id=de6244d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6244d6",
  null
  
)

export default component.exports